export default import.meta.ROLLDOWN_FILE_URL_LBmoEmnTx4MI7lEKmdDiZQ